import { ca } from '@cian/analytics';
import { EUserType } from '../../../../constants/requestDemand';

const cardPage = {
  pageType: 'Card',
  device_type: 'desktop',
};

export const trackBannerClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Click',
    label: 'Banner',
    page: {
      ...cardPage,
      extra: {
        banner_location: 'after_similar',
      },
    },
  });
};

export const trackOpenSmsPopup = (ishomeowner: boolean) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Open',
    label: 'SMS',
    page: {
      ...cardPage,
      extra: {
        selected_user_type: ishomeowner ? 'owner' : 'searcher',
        banner_location: 'after_similar',
      },
    },
  });
};

export const trackCloseBannerPopup = (ishomeowner: boolean) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Close',
    label: 'Banner_popup',
    page: {
      ...cardPage,
      extra: {
        selected_user_type: ishomeowner ? 'owner' : 'searcher',
        banner_location: 'after_similar',
      },
    },
  });
};

export const trackCloseSmsPopup = (ishomeowner: boolean) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Close',
    label: 'SMS_popup',
    page: {
      ...cardPage,
      extra: {
        selected_user_type: ishomeowner ? 'owner' : 'searcher',
        banner_location: 'after_similar',
      },
    },
  });
};

export const trackSmsBack = (ishomeowner: boolean) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Click_back',
    label: 'SMS',
    page: {
      ...cardPage,
      extra: {
        selected_user_type: ishomeowner ? 'owner' : 'searcher',
        banner_location: 'after_similar',
      },
    },
  });
};

export const trackSmsAgain = (ishomeowner: boolean) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Click_again',
    label: 'SMS',
    page: {
      ...cardPage,
      extra: {
        selected_user_type: ishomeowner ? 'owner' : 'searcher',
        banner_location: 'after_similar',
      },
    },
  });
};

export const trackVerifyPhone = (ishomeowner: boolean) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Click_confirm',
    label: 'SMS',
    page: {
      ...cardPage,
      extra: {
        selected_user_type: ishomeowner ? 'owner' : 'searcher',
        banner_location: 'after_similar',
      },
    },
  });
};

export const trackBackToOffer = (ishomeowner: boolean) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Click_back_to_offer',
    label: 'sent',
    page: {
      ...cardPage,
      extra: {
        selected_user_type: ishomeowner ? 'owner' : 'searcher',
        banner_location: 'after_similar',
      },
    },
  });
};

export const trackPhoneVerificationSuccess = (ishomeowner: boolean) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Send',
    label: 'SMS',
    page: {
      ...cardPage,
      extra: {
        selected_user_type: ishomeowner ? 'owner' : 'searcher',
        banner_location: 'after_similar',
      },
    },
  });
};

export const trackSendFormSuccess = (ishomeowner: boolean) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Send',
    label: 'Page',
    page: {
      ...cardPage,
      extra: {
        selected_user_type: ishomeowner ? 'owner' : 'searcher',
        banner_location: 'after_similar',
      },
    },
  });
};

export const trackVerificationPhoneError = (ishomeowner: boolean) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Wrong_code',
    label: 'SMS',
    page: {
      ...cardPage,
      extra: {
        selected_user_type: ishomeowner ? 'owner' : 'searcher',
        banner_location: 'after_similar',
      },
    },
  });
};

export const trackChangedUserType = (userType: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: userType === EUserType.HOME_OWNER ? 'Change_to_owner' : 'Change_to_searcher',
    label: 'Banner',
    page: {
      pageType: 'Card',
      device_type: 'desktop',
      extra: {
        banner_location: 'after_similar',
      },
    },
  });
};

export const trackSendFormClick = (userType: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Click_to_send',
    label: 'Banner',
    page: {
      ...cardPage,
      extra: {
        banner_location: 'after_similar',
        selected_user_type: userType === EUserType.HOME_OWNER ? 'owner' : 'searcher',
      },
    },
  });
};
